import {
  Box,
  Button,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
  Grid,
} from "@mui/material";
// import Grid from "@mui/material/Grid2";
import { Projects } from "../utils/projects";
import Project from "../images/project.png";
import { forwardRef, useEffect, useRef, useState } from "react";
import {
  ArrowCircleLeftOutlined,
  ArrowCircleRightOutlined,
} from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { Controller, useForm } from "react-hook-form";
import { IForm } from "../interfaces/contactVivia";
import {
  confirmation_EN,
  confirmation_FR,
  newDemo_EN,
  newDemo_FR,
} from "../utils/email";
import emailjs from "emailjs-com";
import { toast } from "react-toastify";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import LoadingButton from "@mui/lab/LoadingButton";

const ViviaProjects = forwardRef((props, ref) => {
  const { t, i18n } = useTranslation();
  const [requestDemo, setRequest] = useState(false);
  const projectScroll = useRef<HTMLDivElement>(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));
  const [atStart, setAtStart] = useState(true);
  const [loading, setLoadingButton] = useState(false);
  const {
    control,
    handleSubmit,
    register,
    reset,
    formState: { errors },
  } = useForm<IForm>({
    defaultValues: {
      modules: [],
    },
  });
  console.log("errors", errors);
  const onScroll = (direction: "left" | "right") => {
    if (projectScroll.current) {
      const container = projectScroll.current;
      const containerWidth = container.clientWidth;
      const scrollWidth = container.scrollWidth;
      const currentScroll = container.scrollLeft;

      const scrollAmount = containerWidth * 0.93; // Adjust scroll amount if needed

      if (direction === "left") {
        container.scrollBy({
          left: -scrollAmount,
          behavior: "smooth",
        });
      } else {
        const maxScrollLeft = scrollWidth - containerWidth;

        // 🔁 Go back to start if we're at or near the end
        if (currentScroll >= maxScrollLeft - 5) {
          console.log("Reached end, going back to first item");
          container.scrollTo({
            left: 0,
            behavior: "smooth",
          });
          return;
        }

        container.scrollBy({
          left: scrollAmount,
          behavior: "smooth",
        });
      }
    }
  };
  const checkScrollPosition = () => {
    if (!projectScroll.current) return;
    const container = projectScroll.current;
    const scrollLeft = container.scrollLeft;

    setAtStart(scrollLeft <= 5); // tolérance
  };
  useEffect(() => {
    const container = projectScroll.current;
    if (!container) return;

    checkScrollPosition(); // Initial

    container.addEventListener("scroll", checkScrollPosition);
    window.addEventListener("resize", checkScrollPosition);

    return () => {
      container.removeEventListener("scroll", checkScrollPosition);
      window.removeEventListener("resize", checkScrollPosition);
    };
  }, []);
  const newRequest = async (data: IForm) => {
    setLoadingButton(true);
    console.log("data", data);
    let text;
    let newDemo;
    if (i18n.language === "fr") {
      text = confirmation_FR(data.name);
      newDemo = newDemo_FR(data);
    } else {
      text = confirmation_EN(data.name);
      newDemo = newDemo_EN(data);
    }

    const subjectNew = t(`Nouvelle demande de demo`) + " " + data.name;
    const subjectConfirmation = t(`Merci de nous avoir contactés.`);
    await emailjs
      .send(
        "service_17uejwg", // trouvé dans EmailJS > Email Services
        "template_newContact", // trouvé dans EmailJS > Email Templates
        {
          text: newDemo,
          subjectEmail: subjectNew,
        },
        "fyRV_pkC85mOM6uCo" // trouvé dans EmailJS > Account > API Keys
      )
      .then(() => {
        toast.success("Votre demande a ètè envoyée", {
          // position: "top-center",
          theme: "dark",
          autoClose: 3000, // 3 seconds
        });
      })
      .catch((err) => {
        toast.error(
          "Une erreur inattendue s'est produite. Veuillez réessayer plus tard",
          {
            // position: "top-center",
            theme: "dark",
            autoClose: 3000, // 3 seconds
          }
        );
      });
    await emailjs
      .send(
        "service_17uejwg", // trouvé dans EmailJS > Email Services
        "template_confirmation", // trouvé dans EmailJS > Email Templates
        {
          email: data.email,
          text,
          subjectEmail: subjectConfirmation,
        },
        "fyRV_pkC85mOM6uCo" // trouvé dans EmailJS > Account > API Keys
      )
      .then(() => {
        setLoadingButton(false);
      })
      .catch((err) => {});
    reset({
      name: "",
      email: "",
      phone: "",
      modules: [],
    });
  };
  return (
    <Box ref={ref} sx={{ scrollMarginTop: "80px" }}>
      <Grid
        container
        sx={{
          justifyContent: "center",
          alignItems: "center",
          gap: { xs: 6, lg: 8 },
          display: "flex",
          flexDirection: "column",
          background:
            "radial-gradient(39.87% 39.87% at 50% 50%, #0C3247 0%, #081525 100%)",
          pt: 2,
          pb: 3,
        }}
      >
        <Grid>
          <Typography
            sx={{
              fontFamily: "Orbitron",
              fontWeight: 900,
              fontSize: { xs: "28px", lg: "33px" },
              lineHeight: { xs: "50px", lg: "60px" },
              letterSpacing: "10%",
              textAlign: "center",
              verticalAlign: "middle",
              color: "#FFF",
            }}
          >
            {t("Powering smarter parking")}
          </Typography>
          <Typography
            sx={{
              fontFamily: "Orbitron",
              fontWeight: 900,
              fontSize: { xs: "33px", lg: "39px" },
              lineHeight: { xs: "40px", lg: "60px" },
              letterSpacing: "10%",
              textAlign: "center",
              verticalAlign: "middle",
              color: "#FFF",
              mt: 1,
            }}
          >
            {t("with intelligent, connected systems")}
          </Typography>
        </Grid>
        <Box
          justifyContent="center"
          component="img"
          src={Project}
          alt="project"
          sx={{
            height: "auto",
            width: {
              xs: "90%", // mobile

              md: "60%", // tablette
            },
          }}
        />

        <Grid
          sx={{
            border: "2px solid",
            borderImageSource:
              "radial-gradient(50% 875.74% at 50% 50%, #33BBA4 0%, #1F8FCE 100%)",
            backdropFilter: "blur(23.399999618530273px)",
            borderImageSlice: 1,
            width: "75%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            gap: { xs: 2, md: 3, lg: 5 },
            p: { xs: 1, lg: 3 },
            maxWidth: "100vw",
            overflow: "hidden",

            // position: "relative",
            // pb: 2,
          }}
        >
          <Grid>
            <Typography
              sx={{
                fontFamily: "Orbitron",
                fontWeight: 900,
                fontSize: { xs: "18px", sm: "22px", lg: "28px" },
                lineHeight: { xs: "40px", lg: "60px" },
                letterSpacing: "10%",
                textAlign: "center",
                verticalAlign: "middle",
                color: "#FFF",
              }}
            >
              {t("Turning Vision into Reality")}
            </Typography>
            <Typography
              sx={{
                fontFamily: "Orbitron",
                fontWeight: 900,
                fontSize: { xs: "16px", sm: "20px", lg: "35px" },
                lineHeight: { xs: "40px", lg: "60px" },
                letterSpacing: "10%",
                textAlign: "center",
                verticalAlign: "middle",
                color: "#FFF",
              }}
            >
              {t("Real-time parking business logic")}
            </Typography>
          </Grid>
          <Box sx={{ position: "relative" }}>
            {isMobile && (
              <>
                {!atStart && (
                  <IconButton
                    aria-label="scroll left"
                    onClick={() => onScroll("left")}
                    sx={{
                      position: "absolute",
                      right: 90,
                      top: 90,
                      zIndex: 1,
                      // transform: "translateY(-50%)",
                      color: "#3CB5A1",
                    }}
                  >
                    <ArrowCircleLeftOutlined fontSize="large" />
                  </IconButton>
                )}
                <IconButton
                  aria-label="scroll right"
                  onClick={() => onScroll("right")}
                  sx={{
                    position: "absolute",
                    left: 92,
                    top: 90,
                    zIndex: 1,
                    // transform: "translateY(-10%)",
                    color: "#3CB5A1",
                  }}
                >
                  <ArrowCircleRightOutlined fontSize="large" />
                </IconButton>
              </>
            )}
          </Box>
          <Box
            ref={projectScroll}
            sx={{
              display: "flex",
              overflowX: { xs: "auto", lg: "visible" },

              scrollBehavior: { xs: "smooth", lg: "none" },
              // gap: 2,
              py: 2,
              px: 2,
              alignItems: "flex-start",
              // width: "100vw",
              "&::-webkit-scrollbar": { display: "none" },
              "scrollbar-width": "none",
            }}
          >
            {Projects.map((project, index) => (
              <Grid
                key={index}
                item
                xs={12}
                md={6}
                lg={6}
                sx={{
                  display: "flex",
                  flexShrink: { xs: 0, lg: "initial" },
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  // size: { xs: 12, sm: 12, md: 6, lg: 2.5 },
                  cursor: "pointer",

                  // minWidth: 500,
                }}
              >
                <Box
                  component="img"
                  src={project.image}
                  alt={project.name}
                  sx={{
                    height: "auto",
                    width: {
                      xs: "40%", // mobile

                      md: "60%", // tablette
                      lg: "80%",
                    },
                  }}
                />

                <Typography
                  sx={{
                    fontFamily: "Titillium Web",
                    fontWeight: 400,
                    fontSize: "24px",
                    lineHeight: "100%",
                    letterSpacing: "0%",
                    color: "#FFF",
                    mb: 1,
                    mt: 1,
                    textAlign: "center",
                  }}
                >
                  {project.name}
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Roboto",
                    fontWeight: 400,
                    fontSize: "15px",
                    lineHeight: "100%",
                    letterSpacing: "0%",
                    color: "#3CB5A1",
                    textAlign: "center",
                    width: "100%",
                  }}
                >
                  {project.text}
                </Typography>
              </Grid>
            ))}
          </Box>

          <Grid
            display="flex"
            justifyContent="center"
            gap={{ xs: 2, md: 4 }}
            flexDirection={{ xs: "column", lg: "row" }}
          >
            <Typography
              sx={{
                fontFamily: "Titillium Web",
                fontWeight: 700,
                fontSize: "20px",
                lineHeight: "30px",
                letterSpacing: "4%",
                textAlign: "center",
                verticalAlign: "middle",
                color: "#FFF",
              }}
            >
              {t("Ready to see it in action?")}
            </Typography>
            <Button
              sx={{
                color: "#FFF",
                border: "1px solid #28D1B4",

                bgcolor: " #33BBA4",
              }}
              onClick={() => setRequest(!requestDemo)}
            >
              {t("Request a demo")}
            </Button>
          </Grid>
          {requestDemo && (
            <Grid
              display="flex"
              flexDirection="column"
              gap={3}
              position="relative"
            >
              <Grid
                display="flex"
                gap={3}
                flexDirection={{ xs: "column", md: "row" }}
              >
                <Controller
                  control={control}
                  name="name"
                  rules={{ required: true }}
                  render={({ field: { onChange, value = "" } }) => (
                    <TextField
                      {...register("name", {
                        required: "Saisir votre nom",
                      })}
                      size="small"
                      type="text"
                      placeholder={t("Name *")}
                      id="outlined-basic"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          background: "#FFF",
                          // border: " 1px solid #E2E2E2",
                        },
                      }}
                      value={value}
                      onChange={(event: any) => {
                        onChange(event);
                      }}
                      error={errors?.name ? true : false}
                      helperText={errors?.name?.message}
                    />
                  )}
                />
                <Controller
                  control={control}
                  name="email"
                  rules={{ required: true }}
                  render={({ field: { onChange, value = "" } }) => (
                    <TextField
                      {...register("email", {
                        required: "Saisir votre email",
                        pattern: {
                          value: /\S+@\S+\.\S+/,
                          message: "Verifier votre email",
                        },
                      })}
                      size="small"
                      type="text"
                      placeholder={t("E-mail adress *")}
                      id="outlined-basic"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          background: "#FFF",
                          // border: " 1px solid #E2E2E2",
                        },
                      }}
                      value={value}
                      onChange={(event: any) => {
                        onChange(event);
                      }}
                      error={errors?.email ? true : false}
                      helperText={errors?.email?.message}
                    />
                  )}
                />
              </Grid>
              <Grid
                display="flex"
                gap={3}
                flexDirection={{ xs: "column", md: "row" }}
              >
                <Controller
                  control={control}
                  name="phone"
                  rules={{ required: true }}
                  render={({ field: { onChange, value = "" } }) => (
                    <TextField
                      {...register("phone", {
                        required: false,
                      })}
                      size="small"
                      type="text"
                      placeholder={t("Phone Number")}
                      id="outlined-basic"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          background: "#FFF",
                          // border: " 1px solid #E2E2E2",
                        },
                      }}
                      value={value}
                      onChange={(event: any) => {
                        onChange(event);
                      }}
                    />
                  )}
                />

                <Controller
                  control={control}
                  name="companyName"
                  rules={{ required: true }}
                  render={({ field: { onChange, value = "" } }) => (
                    <TextField
                      {...register("companyName", {
                        required: false,
                      })}
                      size="small"
                      type="text"
                      placeholder={t("Company Name")}
                      id="outlined-basic"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          background: "#FFF",
                          // border: " 1px solid #E2E2E2",
                        },
                      }}
                      value={value}
                      onChange={(event: any) => {
                        onChange(event);
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid
                display="flex"
                gap={3}
                flexDirection={{ xs: "column", md: "row" }}
              >
                <Controller
                  control={control}
                  name="modules"
                  rules={{ required: true }}
                  render={({ field: { onChange, value } }) => (
                    <Select
                      {...register("modules", {
                        required: "Selectionner le(s) module(s)",
                      })}
                      sx={{
                        background: "#FFF",
                        width: { xs: "100%", md: "55%", xl: "48%" },
                      }}
                      multiple
                      value={value ?? []}
                      onChange={onChange}
                      size="small"
                      displayEmpty
                      inputProps={{ "aria-label": "Without label" }}
                      error={errors?.modules ? true : false}
                    >
                      <MenuItem disabled value="">
                        <em>Modules</em>
                      </MenuItem>
                      {Projects.map((project) => (
                        <MenuItem value={project.name}>{project.name}</MenuItem>
                      ))}
                    </Select>
                  )}
                />
                <Controller
                  control={control}
                  name="date"
                  rules={{ required: true }}
                  render={({ field: { onChange, value = null } }) => (
                    <DateTimePicker
                      {...register("date", {
                        required: false,
                      })}
                      inputFormat="DD/MM/YYYY HH:mm:ss"
                      renderInput={(props) => (
                        <TextField
                          size="small"
                          type="text"
                          placeholder={t("preferred time")}
                          id="outlined-basic"
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              background: "#FFF",
                              // border: " 1px solid #E2E2E2",
                            },
                          }}
                          {...props}
                        />
                      )}
                      value={value}
                      onChange={onChange}
                    />
                  )}
                />
              </Grid>
              <Grid container justifyContent="flex-end">
                <LoadingButton
                  sx={{
                    color: "#FFF",
                    border: "1px solid #28D1B4",
                    bgcolor: " #33BBA4",
                    pl: 4,
                    pr: 4,
                  }}
                  loading={loading}
                  onClick={handleSubmit(newRequest)}
                >
                  {t("Send")}
                </LoadingButton>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Box>
  );
});
export default ViviaProjects;
